import { render, staticRenderFns } from "./SelectMainCharacteristic.vue?vue&type=template&id=ca1856e2&scoped=true&"
import script from "./SelectMainCharacteristic.vue?vue&type=script&lang=js&"
export * from "./SelectMainCharacteristic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca1856e2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/tgs-automation/tgs-automation/mojaweb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ca1856e2')) {
      api.createRecord('ca1856e2', component.options)
    } else {
      api.reload('ca1856e2', component.options)
    }
    module.hot.accept("./SelectMainCharacteristic.vue?vue&type=template&id=ca1856e2&scoped=true&", function () {
      api.rerender('ca1856e2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/LocationService/SelectMainCharacteristic.vue"
export default component.exports